import VueSlider from 'vue-3-slider-component';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueSlider', VueSlider);
});
